module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/state.js
 ** module id = 1020
 ** module chunks = 0
 **/